import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import { initializeStore } from '@/redux/initialize-store';
import { getSlugServerSideProps } from '@/utils/slugUtils';
import { PAGES } from '@/constants/pages';

const CategViewWB = dynamic(() => import('@/components/views/CategViewWB'));
CategViewWB.displayName = 'CategViewWB';
const CategView = dynamic(() => import('@/components/views/CategView'));
CategView.displayName = 'CategView';
const CategViewGrid = dynamic(() => import('@/components/views/CategViewGrid'));
CategViewGrid.displayName = 'CategViewGrid';
const ProductView = dynamic(() => import('@/components/views/ProductView'));
ProductView.displayName = 'ProductView';
const LandingView = dynamic(() => import('@/components/views/LandingView'));
LandingView.displayName = 'LandingView';
const CategListingView = dynamic(() => import('@/components/views/CategListingView'));
CategListingView.displayName = 'CategListingView';

export const SpiritSlug = ({ componentType, ...viewProps }) => {
  switch (componentType) {
    case PAGES.CATEG_WB:
      return <CategViewWB {...viewProps} />;
    case PAGES.CATEG_SPIRIT:
      return <CategView {...viewProps} />;
    case PAGES.CATEG_SPIRIT_CU:
      return <CategViewGrid key={viewProps.categId} {...viewProps} />;
    case PAGES.PRODUCT_SPIRIT:
      return <ProductView {...viewProps} />;
    case PAGES.LANDING_PAGE:
      return <LandingView {...viewProps} />;
    case PAGES.CATEG_LISTING:
      return <CategListingView {...viewProps} />;
  }

  console.debug('SpiritSlug: unknown component type', componentType);
  return null;
};

SpiritSlug.propTypes = {
  componentType: PropTypes.oneOf(Object.values(PAGES)).isRequired
};

export default SpiritSlug;

export const getServerSideProps = (async (ctx) => {
  const store = initializeStore({ ssrContext: ctx });
  return getSlugServerSideProps(ctx, store, serverSideTranslations, true);
});
